import bankItau from '../../banksPNG/bankItau.png';

interface IconProps {
	width?: string;
	height?: string;
	alt?: string;
}
export const BancoItauIcon = ({
	width = '17px',
	height = '17px',
	alt = 'Banco Itau',
}: IconProps) => <img src={bankItau} width={width} height={height} alt={alt} />;
